import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import trTranslation from './locales/tr/translation.json';
import enTranslation from './locales/en/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'tr'],
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: { translation: enTranslation },
      tr: { translation: trTranslation },
    },
  });

const syncDocumentLang = (lng) => {
  try {
    document.documentElement.lang = (lng || 'en').split('-')[0];
  } catch (_) {}
};
syncDocumentLang(i18n.resolvedLanguage);
i18n.on('languageChanged', () => syncDocumentLang(i18n.resolvedLanguage));

export default i18n;
